import * as React from 'react';
export const SvgFiletypeAmim = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M11 3V0H2v16h12V3z', fill: '#41bdc6' }),
        React.createElement("path", { d: 'M6.683 12.177L4 13l.67-2.56 4.025-4.114 2.012 1.737zm5.173-5.303l-.862.915L8.982 6.05l.958-.914a.479.479 0 01.67 0l1.246 1.097a.428.428 0 010 .64z', fill: '#fff' }),
        React.createElement("path", { d: 'M11 0l3 3h-3z', fill: '#32848a' })));
};
export default SvgFiletypeAmim;
